import { useEffect, useState } from "react";
import { fileBlobUrl, initials } from "@/lib/api";
import { cn } from "@/lib/utils";

export const UserAvatar = ({ fileId, name, className, testId }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    setSrc(null);
    if (fileId) fileBlobUrl(fileId).then(setSrc).catch(() => setSrc(null));
  }, [fileId]);
  return (
    <span data-testid={testId} className={cn("flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary font-semibold text-primary-foreground", className || "h-8 w-8 text-xs")}>
      {src ? <img src={src} alt={name} className="h-full w-full object-cover" /> : initials(name)}
    </span>
  );
};
